import {
  retailerList,
  retailerCreate,
  retailerUpdate,
  retailerDestroy,
} from '@/services/shop/retailers.service'

export default {
  namespaced: true,
  state: {
    retailers: { data: [], meta: { pagination: { total: 0 } } },
    status: 'init',
  },
  getters: {
    getRetailers: s => s.retailers,
    getStatus: s => s.status,
  },
  mutations: {
    SET_RETAILERS(state, value) { state.retailers = value },
    SET_STATUS(state, value) { state.status = value },
  },
  actions: {
    async fetchRetailers({ commit }, params) {
      commit('SET_STATUS', 'pending')
      try {
        const { data } = await retailerList(params)
        commit('SET_RETAILERS', data)
      } catch (e) {
        this._vm.$root.$notify({ message: e?.response?.data?.message || 'Error', type: 'danger' })
      } finally {
        commit('SET_STATUS', 'init')
      }
    },

    // `params` is the list the screen is looking at (page, per_page and its filters): it is reloaded as it was.
    async saveRetailer({ dispatch }, { form, params }) {
      const { data } = await (form.id ? retailerUpdate(form.id, form) : retailerCreate(form))
      dispatch('fetchRetailers', params)

      return data
    },

    async removeRetailer({ dispatch }, { id, params }) {
      await retailerDestroy(id)
      dispatch('fetchRetailers', params)
    },
  },
}
